export interface LoadSize {
  loadSizeCode: string;
  loadSizeDesc: string;
  loadSizeId: number;
}
